export const initialState = {
  numberOfProviders: 0,
  monthlyAppointments: 0,
  percentageOfNewPatientsVisitMonth: 0,
  averageOrderValueEachPatientPerVisitOrPatientTicketSize: 0,
  paperBasedIntakeDependency: false,
  staffData: {
    monthlyTimeSavingInHours: 0,
    monthlyCostSaving: 0,
    annualCostSavings: 0,
  },
  noShowData: {
    monthlyAppointmentIncrease: 0,
    averageAdditionalRevenuePerMonth: 0,
    averageAdditionalRevenueInYear: 0,
  },
  paymentCollectionData: {
    additionalRevenue: 0,
    annualIncrease: 0,
  },
  automatedSavings: {
    monthlyHoursSavedFromVerification: 0,
    monthlyCostSavings: 0,
    annualCostSavings: 0,
  },
  paymentCollectionInputValue: 0,
  reduceNoShowInputValue: 0,
  saveStaffHoursInputValues: {
    avgEbVerificaitonPerMonth: 0,
    perProviderCost: 0,
  },
  costGoingPaperless: {
    monthlyCostSavings: 0,
    annualCostSavings: 0,
  },
};

const roiReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "UPDATE_NO_OF_PROVIDERS":
      return {
        ...state,
        numberOfProviders: payload.numberOfProviders,
      };
    case "UPDATE_MONTHLY_APPOINTMENTS":
      return {
        ...state,
        monthlyAppointments: payload.monthlyAppointments,
      };
    case "UPDATE_NEW_PATIENT_VISITS_PER_MONTH":
      return {
        ...state,
        percentageOfNewPatientsVisitMonth: payload.percentageOfNewPatientsVisitMonth,
      };
    case "UPDATE_PATIENT_TICKET_SIZE":
      return {
        ...state,
        averageOrderValueEachPatientPerVisitOrPatientTicketSize:
          payload.averageOrderValueEachPatientPerVisitOrPatientTicketSize,
      };
    case "UPDATE_PAPER_BASED_DEPENDENCY":
      return {
        ...state,
        paperBasedIntakeDependency: payload.paperBasedIntakeDependency,
      };
    case "UPDATE_STAFF_DATA":
      return {
        ...state,
        staffData: {
          ...state.staffData,
          ...payload.staffData,
        },
      };
    case "UPDATE_NO_SHOW_DATA":
      return {
        ...state,
        noShowData: {
          ...state.noShowData,
          ...payload.noShowData,
        },
      };
    case "UPDATE_PAYMENT_COLLECTION_DATA":
      return {
        ...state,
        paymentCollectionData: { ...state.paymentCollectionData, ...payload.paymentCollectionData },
      };
    case "UPDATE_AUTOMATED_SAVINGS_DATA":
      return {
        ...state,
        automatedSavings: { ...state.automatedSavings, ...payload.automatedSavings },
      };

    case "UPDATE_NO_SHOW_INPUT_VALUE":
      return {
        ...state,
        reduceNoShowInputValue: payload.reduceNoShowInputValue,
      };
    case "UPDATE_PAYMENT_COLLECTION_INPUT_VALUE":
      return {
        ...state,
        paymentCollectionInputValue: payload.paymentCollectionInputValue,
      };

    case "UPDATE_SAVE_STAFF_HOURS_INPUT_VALUE":
      return {
        ...state,
        saveStaffHoursInputValues: {
          ...payload.saveStaffHoursInputValues,
        },
      };
    case "UPDATE_COST_GOING_PAPER_LESS":
      return {
        ...state,
        costGoingPaperless: {
          ...payload.costGoingPaperless,
        },
      };

    default:
      throw new Error(`No case for type ${type} found in shopReducer.`);
  }
};

export default roiReducer;
